import { ReactNode } from "react";
import { useDelete } from "../Fetch/useFetch.tsx";
import toast from "../../module/Toast/toast.tsx";
import Modal, { ActionBar, Content } from "./Modal.tsx";
import styles from "./Modal.module.css";

const DeleteModalBody = ({
  query,
  id,
  closeModal,
  onDelete,
  content,
}: DeleteModalType) => {
  const del = useDelete(id ? `${query}/${id}` : `${query}`, {
    onResolve: (res) => {
      onDelete && onDelete(res);
      toast.success("L'élément a bien été supprimé");
      closeModal();
    },
    onReject: async (error) => {
      toast.error(
        <>
          {"Erreur lors de la suppression de l'élément"} &nbsp;:{" "}
          {await error.text()}
        </>,
      );
      closeModal();
    },
  });

  return (
    <>
      <Content>{content}</Content>
      <ActionBar>
        <button onClick={closeModal}>Annuler</button>
        <button
          className={styles.active}
          onClick={async () => {
            try {
              await del.run();
            } catch (e) {
              toast.error(
                <>
                  {"Erreur lors de la suppression de l'élément"} &nbsp;:{" "}
                  {e.message}
                </>,
              );
            }
          }}
        >
          Valider
        </button>
      </ActionBar>
    </>
  );
};

const DeleteModal = ({
  visible,
  closeModal,
  header = "Suppression d'un élément",
  query,
  id,
  onDelete,
  content = "Voulez-vous supprimer cet élement ?",
}: DeleteModalType) => {
  return (
    <Modal {...{ visible, header, closeModal }}>
      <DeleteModalBody
        query={query}
        id={id}
        closeModal={closeModal}
        onDelete={onDelete}
        content={content}
      />
    </Modal>
  );
};

type DeleteModalType = {
  visible: boolean;
  header?: ReactNode | undefined;
  closeModal: () => boolean;
  id?: string | undefined;
  query: string;
  onDelete?: () => void | undefined;
  content?: string | undefined;
};

export default DeleteModal;
